import React from "react";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Input } from "@my-scoot/component-library-legacy";

const ExlySearchInput = (props) => {
  const {
    input,
    meta,
    onChange,
    inputProps,
    labelField,
    descriptionField,
    fetchSearchData,
    placeholder,
    ...rest
  } = props;
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");

  const handleChange = (e, newValue) => {
    input.onChange(newValue);
  };

  const onInputChange = (event, newInputValue) => {
    setInputValue(newInputValue);
    if(newInputValue !== input.value?.[labelField])  input.onChange(null);
  };

  React.useEffect(() => {
    fetchSearchData(inputValue || "").then((data) => setOptions(data));
  }, [inputValue]);

  return (
    <>
      <Autocomplete
        options={options}
        value={input.value || ''}
        getOptionSelected={(option, value) =>
          option.hsn_code === value.hsn_code
        }
        onChange={handleChange}
        onInputChange={onInputChange}
        getOptionLabel={(option) => option?.[labelField] || inputValue}
        renderOption={(option) =>
          option?.[labelField]
            ? `${option?.[labelField]} ${option?.[descriptionField]}`
            : ""
        }
        renderInput={(params) => (
          <div ref={params.InputProps.ref}>
            <Input
              {...params}
              {...inputProps}
              placeholder={placeholder}
              icon={<SearchRoundedIcon />}
            />
          </div>
        )}
        {...rest}
      />
      <div style={{ color: "red", fontSize: "12px" }}>
        {meta.error && meta.touched ? meta.error : null}
      </div>
    </>
  );
};

export default ExlySearchInput;
